import React, {useState, useEffect, useRef, useCallback} from 'react'
import { useSelector, useDispatch } from 'react-redux';
import Announcements from '../announcements/Announcements';
import instance from '../../axios';
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from '@mui/material';


// Farruh Olimov, [12/14/2022 10:39 PM]
// /ads?mosque_id=1 masjid bo'yicha
// /ads?category_id=1 kategoriya bo'yicha
// /ads?status=1 status bo'yicha
// /ads/results?search_query=birnima  search

function MyAds() {
      const { categoriesArray, subCategoriesArr } = useSelector(
            (state) => state.categories
          );
        
          const [categoryInputValue, setCategoryInputValue] = useState(0);
          const [subCategoryInputValue, setSubCategoryInputValue] = useState(0);
          const [announcements, setAnnouncements] = useState([]);
          const [loading, setLoading] = useState(false);
          // const [isSorting, setIsSorting] = useState(false);
          const [ad_status, set_ad_status] = useState(0);
          const [currentPage, setCurrentPage] = useState(1);
          const [nextPage, setNextPage] = useState(2);
          const [totalCount, setTotalCount] = useState(1);
          const [totalPages, setTotalPages] = useState(1);
          const [user, setUser] = useState({});
          const [mosqueId, setMosqueId] = useState("");
          const [isFetching, setIsFetching] = useState(false);
        
          const tgId = window?.Telegram?.WebApp?.initDataUnsafe?.user?.id
            ? window?.Telegram?.WebApp?.initDataUnsafe?.user?.id
            : "1598016165";
        
          const dispatch = useDispatch();
        
          ///////////
          const observer = useRef();
          const lastElement = useCallback(
            (node) => {
              if (loading) return;
              if (observer.current) observer.current.disconnect();
              observer.current = new IntersectionObserver((entries) => {
                if (entries[0].isIntersecting) {
                  setCurrentPage((prev) => {
                    if (prev < totalPages) {
                      return prev + 1;
                    }
                  });
                }
              });
        
              if (node) observer.current.observe(node);
            },
            [loading]
          );
          /////////////////////////////////////
          ////////////////////////////////////
        
          function getDataByStatus(id, status) {
            setLoading(true);
            instance.get(`api/ads/`);
          }
        
          useEffect(() => {
            setAnnouncements([]);
            setCurrentPage(1);
            setNextPage(2);
          }, [ad_status]);
        
          /////////////////////////////////////
          ////////////////////////////////////
          // Get user info
          function getUserInfo(id) {
            instance.get(`api/users/tg/${id}`).then((res) => {
              setMosqueId(res?.data?.data?.user?.mosque_admin?.mosque_id);
            });
          }
          useEffect(() => {
            if (tgId) {
              getUserInfo(tgId);
            }
          }, [tgId]);
          /////////////////////////////////////
          ////////////////////////////////////
        
          function getAdsData(id, currentPage) {
            setLoading(true);
        
            let abc = `mosque_id=${id}`;
            let queryStatus = ad_status > 0 ? `&status=${ad_status}` : "";
        
            if (id && !isFetching) {
              instance
                .get(`api/ads?${abc}&page=${currentPage}${queryStatus}`, {
                  headers: {
                    Authorization: `Telegram ${id}`,
                  },
                })
                .then((res) => {
                  if (currentPage === nextPage) {
                    setAnnouncements((prev) => {
                      return [...new Set([...prev, ...res.data.data.ads])];
                    });
                  } else {
                    setAnnouncements(res.data.data.ads);
                  }
                  setTotalPages(res.data.data.pagination.pages);
                  setLoading(false);
                })
                .catch((err) => {
                  setLoading(false);
                })
                .finally((f) => {
                  setLoading(false);
                });
            } else {
              setLoading(false);
            }
          }
        
          useEffect(() => {
            getAdsData(mosqueId, currentPage);
          }, [mosqueId, ad_status]);
        
          //////////////////////////////
          //////////////////////////////
          //   Get data by pages
          function getDataByPage(id, currentPage) {
            setLoading(true);
            setIsFetching(true);
            let abc = `mosque_id=${id}`;
            let status = ad_status > 0 ? `&status=${ad_status}` : "";
        
            instance
              .get(`api/ads?${abc}&page=${currentPage}${status}`, {
                headers: {
                  Authorization: `Telegram ${id}`,
                },
              })
              .then((res) => {
                setAnnouncements((prev) => {
                  setLoading(false);
                  return [...new Set([...prev, ...res.data.data.ads])];
                });
              })
              .catch((err) => {
                setLoading(false);
              })
              .finally((f) => {
                setLoading(false);
                setIsFetching(false);
              });
          }
        
          useEffect(() => {
            if (mosqueId && currentPage <= totalPages) {
              getDataByPage(mosqueId, currentPage);
            }
          }, [currentPage]);
          //////////////////////////////
          //////////////////////////////
          //////////////////////////////////////////////////
          //////////////////////////////////////////////
          //////////////////////////////////////////////////      
  return (
      <div className="bg-gray h-[150vh]">
      <div className="container mx-auto p-2 pt-5">
        <h1
          className="my-4 text-xl"
          style={{ width: "336px", height: "32px", fontWeight: "400" }}>
          Mening E{"'"}lonlarim
        </h1>
        <FormControl>
          <FormLabel>Statuslar</FormLabel>
          <RadioGroup
            row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
            value={ad_status}
            onChange={(e) => {
              set_ad_status(e.target.value);
            }}>
            <FormControlLabel value={0} control={<Radio />} label="Barchasi" />
            <FormControlLabel value={1} control={<Radio />} label="Aktiv" />
            <FormControlLabel
              value={2}
              control={<Radio />}
              label="Yakunlangan"
            />
          </RadioGroup>
        </FormControl>

        <hr className="w-full bg-gray-300 mb-2 h-0.5" />

        <Announcements
          data={announcements}
          loading={loading}
          lastElement={lastElement}
        />
      </div>
    </div>    
  )
}

export default MyAds